
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { MapPin, Share2, Star } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

const ShareSection = () => {
  const { t, language } = useLanguage();
  
  const getTitle = () => {
    return language === 'en' ? 'Ready to Share Your Rental Experience?' : '準備分享您的租屋經驗了嗎？';
  };

  const getDescription = () => {
    return language === 'en' ? 'Help others make informed decisions by sharing your honest feedback.' : '透過分享您的真實經驗，幫助他人做出更明智的租屋決定。';
  };

  const getButtonText = () => {
    return language === 'en' ? 'Share Your Experience' : '分享您的經驗';
  };
  
  return (
    <section className="py-16 bg-background">
      <div className="container">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-4">
            {getTitle()}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {getDescription()}
          </p>
        </div>
        
        <div className="flex justify-center">
          <Button asChild size="lg" className="gap-2">
            <Link to="/submit">
              <Share2 className="w-4 h-4" />
              {getButtonText()}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ShareSection;
